import React, { useMemo, memo } from 'react';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

interface IProps {
  operations: Operation[],
  operationsSelected: string[]
}

// Runtime dependency
const VariableRatePlugin: React.FC<IProps> = React.lazy(() => importFromS3('variable-rate'));

export const VariableRatePluginContainer: React.FC<IProps> = memo(({ operations, operationsSelected }: IProps) => {
  const { isLoading, operation: impersonatedOperation } = useImpersonatedOperation();
  const selectedOperations = useMemo(() => impersonatedOperation 
    ? [impersonatedOperation.operationId] 
    : operationsSelected, 
  [impersonatedOperation, operationsSelected]);

  if (isLoading || !selectedOperations.length) return null;

  return (
    <VariableRatePlugin
      operations={operations}
      operationsSelected={selectedOperations}
    />
  );
}, (prevProps, nextProps) => prevProps.operationsSelected === nextProps.operationsSelected);